module.exports = __webpack_public_path__ + "fonts/Golos-Text_Bold.58fcc08.woff";